import src from "IMAGE";
export default { src, width: 578, height: 176, blurWidth: 0, blurHeight: 0};
